import Dropdown from "@/components/tangerina/Dropdown";
import { TOrderBy } from "@/services/requests/Recommendation/types/template8";
import React, { useMemo, useState } from "react";

type TOrderByOptions = TOrderBy['options'][0];

type TOption = TOrderByOptions & {
  index: number;
}

type TProps = {
  title: string;
  options: TOrderBy['options'];
  onSortChange: (selected: TOption) => void;
};

export default function Sort({ title, options, onSortChange }: TProps) {
  const [selectedOption, setSelectedOption] = useState<TOption>({
    ...options[0],
    index: 0,
  });

  const dropdownOptions = useMemo(() => {
    return options.map((option, index) => ({
      ...option,
      index,
    }));
  }, [options, selectedOption]);

  const handleSortChange = (option: TOption) => {
    setSelectedOption(option);
    onSortChange(option);
  }

  return (
    <div className="vitrine-template8__sort">
      <tgr-text-description>{title}</tgr-text-description>
      <div>
        <Dropdown options={dropdownOptions} selected={selectedOption} onSelect={handleSortChange} />
      </div>
    </div>
  )
}